import { StateDescription } from './StateDescription'

export function GroupedCardDescription() {
  return (
    <StateDescription title="What “grouped” means">
      When we send one application to Rocklake, the wholesaler that places Dellwood and other carriers, each
      coverage line comes back as its own result. Dellwood can therefore answer twice: once for cargo and once
      for auto liability. Production folds results from the same carrier and the same application into one
      card, so the customer sees one offer from Dellwood instead of one card per coverage. The grouping code
      is in <code className="font-mono">groupQuoteCards.ts</code>.
    </StateDescription>
  )
}
